import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Result, Button } from 'antd';
import { LayoutPage } from 'components/layouts';
import { withRouter } from 'react-router-dom';

import './style.css';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(error, info);
  }

  render() {
    const { hasError } = this.state;
    const { children, history } = this.props;

    if (hasError) {
      return (
        <LayoutPage className="error-page">
          <LayoutPage.Container className="wrapper">
            <Result
              style={{ width: '100%' }}
              status="500"
              title="500"
              subTitle="Sorry, something went wrong."
              extra={
                <Button
                  type="primary"
                  onClick={() => {
                    history.push('/');
                  }}
                >
                  Back Home
                </Button>
              }
            />
          </LayoutPage.Container>
        </LayoutPage>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default withRouter(ErrorBoundary);
